export default "__VITE_ASSET__HSJTRsmz__"